module.exports = __webpack_public_path__ + "img/VaIcons.aabb1789.svg";